import { render, staticRenderFns } from "./TasksListing.vue?vue&type=template&id=20bbf4da&scoped=true&"
import script from "./TasksListing.vue?vue&type=script&lang=js&"
export * from "./TasksListing.vue?vue&type=script&lang=js&"
import style0 from "./TasksListing.vue?vue&type=style&index=0&id=20bbf4da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bbf4da",
  null
  
)

export default component.exports